import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import WebDatatable from 'app/shared/datatable/web/datatable';
import MobileDatatable from 'app/shared/datatable/mobile/datatable';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { formatDateForDisplay } from 'app/shared/utils/date';
import { useSMSLogService } from 'hooks/messaging/logs/sms';
import { Badge } from 'app/shared/badge';

export const SMSMessageLogs = ({ id: message_id }) => {
  const { is_mobile_view } = useSelector((state) => state.metadata);
  const { fetchSMSLogs, searchSMSLogs } = useSMSLogService();

  const [logs, setLogs] = useState({});
  const [is_search_mode, setSearchMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [total_logs, setTotalLogs] = useState(0);

  const config = {
    actions: {},
    css: {},
    fields: [
      {
        title: 'Phone number',
        key: 'to',
        isTitle: true,
        formatter: (value) => value || 'N/A'
      },
      {
        title: 'Cost',
        key: 'cost',
        // isTagline: true,
        formatter: (value) => value || '0.0'
      },
      {
        title: 'Time sent',
        key: 'time_stamp',
        isMetadata: true,
        formatter: (value) => formatDateForDisplay(value)
      },
      {
        title: 'Status',
        key: 'status',
        formatter: (value) => <Badge type={value === 'failed' ? 'red' : 'green'} text={value} />
      }
    ],
    is_search_mode,
    items: Object.values(logs).sort((a, b) => b.time_stamp - a.time_stamp),
    search_key: 'to,status',
    search_text: ''
  };

  const handleDataRequest = async (page, population = 10) => {
    if (loading) return;
    setLoading(true);

    const { logs, size } = await fetchSMSLogs({
      query_string: `resource_id=${message_id}&page=${page}&population=${population}&sort_by=-created_on`
    });

    setLogs(() => ({ ...logs.reduce((s, a) => ({ ...s, [a.time_stamp]: a }), {}) }));
    setTotalLogs(() => size);
    setLoading(false);
  };

  const handleSearchRequest = async (keys, keyword, page, population = 10) => {
    setLoading(true);
    if (!keys) return;
    const { logs, size } = await searchSMSLogs(keys, `${keyword}`, {
      query_string: `resource_id=${message_id}&page=${page}&population=${population}&sort_by=-created_on`
    });

    setLogs(() => ({ ...logs.reduce((s, a) => ({ ...s, [a.time_stamp]: a }), {}) }));
    setTotalLogs(() => size);
    setLoading(false);
  };

  return (
    <GridRow>
      <GridColumn span={4}>
        {is_mobile_view ? (
          <MobileDatatable
            config={config}
            action={() => {}}
            onClick={() => {}}
            onListModeChange={setSearchMode}
            onDataRequest={handleDataRequest}
            onSearchRequest={handleSearchRequest}
            showHeader
          />
        ) : (
          <WebDatatable
            config={{
              ...config,
              num_of_rows: 10,
              total_count: total_logs
            }}
            action={() => {}}
            onClick={() => {}}
            checkbox
            loading_data={loading}
            table_actions={[]}
            onDataRequest={handleDataRequest}
            onSearchRequest={handleSearchRequest}
          />
        )}
      </GridColumn>
    </GridRow>
  );
};
